// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_FacetSlider.scss
// module id = 614
// module chunks = 13 88